/*!

=========================================================
* Argon Dashboard React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useState } from "react";
import classnames from "classnames";
import NumberFormat from "react-number-format"

// reactstrap components
import {
    Card,
    CardBody,
    CardTitle,
    Container,
    Row,
    Col,
    NavItem,
    NavLink,
    Nav,
    TabContent,
    TabPane,
    CardHeader,
    Button,
    FormGroup,
    InputGroup,
    Input,
    InputGroupAddon,
    InputGroupText,
    Modal
} from "reactstrap";
import { normalizeUnits } from "moment";

const accounts = [
    {
        accountType: 1,
        accountNumber: "000123456789",
        secuence: 1,
        system: 30,
        balance: 2000000
    },
    {
        accountType: 1,
        accountNumber: "000147852369",
        secuence: 1,
        system: 30,
        balance: 2000000.25
    }
];

const contacts = [
    {
        id: 1,
        name: "Diego Alejandro Torres Niño",
        nickName: "Diego"
    },
    {
        id: 2,
        name: "Cristian Camilo Torres Niño",
        nickName: "Camilo"
    },
    {
        id: 3,
        name: "Diego Alejandro Torres Niño",
        nickName: "Diego"
    },
    {
        id: 4,
        name: "Cristian Camilo Torres Niño",
        nickName: "Camilo"
    },
    {
        id: 5,
        name: "Diego Alejandro Torres Niño",
        nickName: "Diego"
    },
    {
        id: 6,
        name: "Cristian Camilo Torres Niño",
        nickName: "Camilo"
    }
];

const contactSelected = {
    id: 1,
    name: "Diego Alejandro Torres Niño",
    nickName: "Diego"
};

const AccountsContact = [
    {
        alias: "CuenDiego",
        accountNumber: "000123456789",
        Bank: "BBVA"
    },
    {
        alias: "CuenDiego2",
        accountNumber: "0123458794564",
        Bank: "Avvillas",
    }
];

const CardLoan = props => {
    return (
        <Col lg="12" xl="12" className="pt-3">
            <Card className="mb-xl-0 shadow">
                <CardBody className="">
                    <Row>
                        <div className="col-auto ml-4">
                            <Row>
                                <span class="mb-0">Préstamo No. {props.account.accountNumber}</span>
                            </Row>
                            <Row>
                                <span class="mb-0 text-sm">Deudo <NumberFormat value={props.account.balance} displayType={'text'} thousandSeparator={true} prefix={'$'} /></span>
                            </Row>
                        </div>
                    </Row>
                </CardBody>
            </Card>
        </Col>

    );
};

const CardAccount = props => {
    return (
        <Col lg="12" xl="12" className="pt-3">
            <Card className="mb-xl-0 shadow">
                <CardBody className="">
                    <Row>
                        <div className="col-auto ml-4">
                            <Row>
                                <span class="mb-0">Cuenta de Ahorros No. {props.account.accountNumber}</span>
                            </Row>
                            <Row>
                                <span class="mb-0 text-sm">Disponible  <NumberFormat value={props.account.balance} displayType={'text'} thousandSeparator={true} prefix={'$'} /></span>
                            </Row>
                        </div>
                    </Row>
                </CardBody>
            </Card>
        </Col>

    );
};

const CardContact = props => {
    if (props.isActive) {
        return (
            <Col lg="12" xl="12" className="pt-3" >
                <Card className="mb-xl-0 shadow">
                    <div className="">
                        <Row>
                            <div className="col-auto mr-3">
                                <GetInitial contact={props.contact}></GetInitial>
                            </div>
                            <div className="col">
                                <Row>
                                    <span class="mt-2 text-sm h4">{props.contact.name}</span>
                                </Row>
                                <Row>
                                    <span class="mb-2 text-sm">{props.contact.nickName}</span>
                                </Row>
                            </div>
                            <div className="col-auto mr-3 vertical-center">
                                <Row className="m-4">
                                    <a className="button"><i className="fas fa-chevron-right" /></a>
                                </Row>
                            </div>
                        </Row>
                    </div>
                </Card>
            </Col>
        );
    } else {
        return (
            <Col lg="12" xl="12" className="pt-3">
                <div className="mb-xl-0 shadow card" style={{ backgroundColor: '#FFFFFF' }}>
                    <div className="">
                        <Row>
                            <div className="col-auto mr-3">
                                <GetInitial contact={props.contact}></GetInitial>
                            </div>
                            <div className="col">
                                <Row>
                                    <span class="mt-2 text-sm h4">{props.contact.name}</span>
                                </Row>
                                <Row>
                                    <span class="mb-2 text-sm">{props.contact.nickName}</span>
                                </Row>
                            </div>
                        </Row>
                    </div>
                </div>
            </Col>
        );
    }
};

const CardAccountContact = props => {
    return (
        <Col lg="12" xl="12" className="pt-3">
            <Card className="mb-xl-0 shadow">
                <div className="">
                    <Row>
                        <div className="col-auto vertical-center">
                            <Row className="m-4">
                                <i className="fas fa-money-bill text-primary" />
                            </Row>
                        </div>
                        <div className="col">
                            <Row>
                                <span class="mt-1 text-sm h4">{props.accountContact.alias}</span>
                            </Row>
                            <Row>
                                <span class="mt-0 mb-0 text-sm">Ahorros No. {props.accountContact.accountNumber}</span>
                            </Row>
                            <Row>
                                <span class="mb-1 text-sm">{props.accountContact.Bank}</span>
                            </Row>
                        </div>
                        <div className="col-auto mr-3 vertical-center">
                            <Row className="m-4">
                                <a className="button"><i className="fas fa-chevron-right" /></a>
                            </Row>
                        </div>
                    </Row>
                </div>
            </Card>
        </Col>
    );
};

const GetInitial = props => {
    if (props.contact.name !== null) {
        var initial = props.contact.name.substr(0, 1);
        return <div class="icon icon-shape bg-green text-white shadow" style={{ borderRadius: 0, borderTopLeftRadius: 6 + 'px', borderBottomLeftRadius: 6 + 'px', width: 4.5 + 'rem', height: 4.5 + 'rem' }}>{initial}</div>
    } else
        return "";
}


class NavsTransfer extends React.Component {
    state = {
        tabs: 1
    };
    toggleModal = state => {
        this.setState({
            [state]: !this.state[state]
        });
    };
    toggleNavs = (e, state, index) => {
        e.preventDefault();
        this.setState({
            [state]: index
        });
    };
    render() {
        return (
            <>
                <Container >
                    <Container fluid className="header pb-4 pt-5 pt-md-8">
                        <Row>
                            <Col xl="3" lg="2"></Col>

                            <Col xl="6" lg="8">
                                <DivStepper>
                                    <DivStep>
                                        <div className="justify-content-center m-4 justify-content-center">
                                            <h2 class="ml-2 text-center"> Datos Básicos del Préstamo </h2>
                                        </div>
                                        <Col xl="12" md="12" sm="12">
                                            <FormGroup>
                                                <select class="selectpicker" placeholder="Tipo de Documento" className="form-control input-group-alternative" data-live-search="true">
                                                    <option data-tokens="ketchup mustard">Tipo de Préstamo</option>
                                                    <option data-tokens="mustard">Tarjeta de Identidad</option>
                                                    <option data-tokens="frosting">Cédula de Extranjería</option>
                                                </select>
                                            </FormGroup>
                                        </Col>
                                        <Col xl="12" md="12" sm="12">
                                            <FormGroup>
                                                <InputGroup className="input-group-alternative">
                                                    <Input placeholder="Valor del Prestamo" type="text" />
                                                    <InputGroupAddon addonType="append">
                                                        <InputGroupText>
                                                            <i className="ni ni-single-02" />
                                                        </InputGroupText>
                                                    </InputGroupAddon>
                                                </InputGroup>
                                            </FormGroup>
                                        </Col>
                                        <Col xl="12" md="12" sm="12">
                                            <FormGroup>
                                                <InputGroup className="input-group-alternative">
                                                    <Input placeholder="Plazo" type="text" />
                                                    <InputGroupAddon addonType="append">
                                                        <InputGroupText>
                                                            <i className="ni ni-single-02" />
                                                        </InputGroupText>
                                                    </InputGroupAddon>
                                                </InputGroup>
                                            </FormGroup>
                                        </Col>
                                        <Col xl="12" md="12" sm="12">
                                            <FormGroup>
                                                <select class="selectpicker" placeholder="Tipo de Docuemnto" className="form-control input-group-alternative" data-live-search="true">
                                                    <option data-tokens="ketchup mustard">Unidades del Plazo</option>
                                                    <option data-tokens="mustard">Tarjeta de Identidad</option>
                                                    <option data-tokens="frosting">Cédula de Extranjería</option>
                                                </select>
                                            </FormGroup>
                                        </Col>
                                    </DivStep>
                                    <DivStep>
                                        <div className="justify-content-center">
                                            <h2 class="ml-2"> Ingrese el valor a cancelar </h2>
                                        </div>
                                        <FormGroup>
                                            <InputGroup className="input-group-alternative mb-4">
                                                <Input placeholder="Valor a transferir" type="text" />
                                                <InputGroupAddon addonType="append">
                                                    <InputGroupText>
                                                        <i className="fas fa-dollar-sign" />
                                                    </InputGroupText>
                                                </InputGroupAddon>
                                            </InputGroup>
                                        </FormGroup>
                                    </DivStep>
                                    <DivStep>
                                        <div className="justify-content-center">
                                            <h2 class="ml-2"> Elige la cuenta con la que pagar </h2>
                                        </div>
                                        <Row>
                                            {accounts.map(account => {
                                                return <CardAccount account={account} key={account.accountNumber} />
                                            })}
                                        </Row>
                                    </DivStep>
                                    <DivStep>
                                        <div className="justify-content-center">
                                            <h2 class="ml-2"> Vas a cancelar </h2>
                                        </div>
                                        <div className="card p-4" style={{ listStyle: "none", padding: 0 + 'px', margin: 5 + 'px' }}>
                                            <ul className style={{ listStyle: "none", padding: 0 + 'px', margin: 5 + 'px' }}>
                                                <li style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #acbac9", padding: "15px 0" }}>
                                                    <p style={{ fontWeight: 600, fontStyle: "normal", fontStretch: "normal", lineHeight: 1.08 }}>Valor</p>
                                                    <p style={{ textAlign: "right", margin: 0 }}>10000</p>
                                                </li>
                                                <li style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #acbac9", padding: "15px 0" }}>
                                                    <p style={{ fontWeight: 600, fontStyle: "normal", fontStretch: "normal", lineHeight: 1.08 }}>Costo</p>
                                                    <p style={{ textAlign: "right", margin: 0 }}>7750</p>
                                                </li>
                                                <li style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #acbac9", padding: "15px 0" }}>
                                                    <p style={{ fontWeight: 600, fontStyle: "normal", fontStretch: "normal", lineHeight: 1.08 }}>Hacia</p>
                                                    <div style={{ textAlign: "right", margin: 0 }}>
                                                        <p style={{ margin: 0 }}> Prestamo No. 702766010 </p>
                                                    </div>
                                                </li>
                                                <li style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #acbac9", padding: "15px 0" }}>
                                                    <p style={{ fontWeight: 600, fontStyle: "normal", fontStretch: "normal", lineHeight: 1.08 }}>Desde</p>
                                                    <div style={{ textAlign: "right", margin: 0 }}>
                                                        <p style={{ margin: 0 }}>Ahorros No. 702766010</p>
                                                        <p style={{ margin: 0 }}>Disponible $15.792.276</p>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                        <Button onClick={() => this.toggleModal("notificationModal")} block size="lg" className="bg-gradient-primary text-white btn shadow btn-rounded">
                                            Transferir
                        </Button>
                                        <Modal
                                            className="modal-dialog-centered modal-primary"
                                            contentClassName="bg-gradient-primary"
                                            isOpen={this.state.notificationModal}
                                            toggle={() => this.toggleModal("notificationModal")}
                                        >
                                            <div className="modal-header">
                                                <button
                                                    aria-label="Close"
                                                    className="close"
                                                    data-dismiss="modal"
                                                    type="button"
                                                    onClick={() => this.toggleModal("notificationModal")}
                                                >
                                                    <span aria-hidden={true}>×</span>
                                                </button>
                                            </div>
                                            <div className="modal-body">
                                                <div className="py-3 text-center">
                                                    <i className="fas fa-lock ni-3x" />
                                                    <h4 className="heading mt-4">Verifica la transferecia con el número que se envió a tu celular.</h4>
                                                    <form role="form" class="">
                                                        <div class="form-group">
                                                            <div class="input-group-merge input-group-alternative input-group">
                                                                <div class="input-group-prepend">
                                                                    <span class="input-group-text">
                                                                        <i class="ni ni-lock-circle-open"></i>
                                                                    </span>
                                                                </div>
                                                                <input placeholder="Password" type="password" class="form-control" />
                                                            </div>
                                                        </div>
                                                        <div class="text-center">
                                                            <Button onClick={() => this.toggleModal("notificationModal")} block size="lg" className="bg-gradient-primary text-white btn shadow btn-rounded">
                                                                Verificar Transacción
                                </Button>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>

                                        </Modal>
                                    </DivStep>
                                </DivStepper>
                            </Col>
                            <Col xl="3" lg="2"></Col>
                        </Row>
                    </Container>
                </Container>
            </>

        );
    }
}

export function DivStep({ children }) {
    return <>{children}</>
}

export function Step(props) {
    if (props.current === props.step) {
        return (<li>
            <div className="stepper-content-items">
                <span className="stepper-number-active"></span>
                <span className="stepper-label-active">{props.label}</span>
            </div>
        </li>)
    } else if (props.current > props.step) {
        return (<li>
            <div className="stepper-content-items">
                <img alt="check-copy" class="stepper-number-done" src={require("../../assets/img/bank/check.svg").default} />
                <span className="stepper-label">{props.label}</span>
            </div>
        </li>)
    } else {
        return (<li>
            <div className="stepper-content-items">
                <span className="stepper-number"></span>
                <span className="stepper-label">{props.label}</span>
            </div>
        </li>)
    }
}

export function Progress(props) {
    const styleProgress = { width: props.current * 33.33 + '%' };
    return <div style={styleProgress} className="progress-bar"></div>
}

export function LineStepper(props) {
    return (
        <>
            <div style={{ position: "relative" }}>
                <div className="stepper-line">
                    <div>
                        <Progress current={props.current}></Progress>
                    </div>
                </div>
                <ul className="stepper-content">
                    <Step current={props.current} step={0} label={"Datos basicos"}></Step>
                    <Step current={props.current} step={1} label={"Valor"}></Step>
                    <Step current={props.current} step={2} label={"Desde"}></Step>
                    <Step current={props.current} step={4} label={"Confirma"}></Step>
                </ul>
            </div>
        </>
    );
};

export function DivStepper({ children, ...props }) {
    const childrenArray = React.Children.toArray(children);
    const [step, setStep] = useState(0);
    const currentChild = childrenArray[step];
    if (step != childrenArray.length - 1) {
        return (
            <div {...props}>
                <LineStepper current={step}></LineStepper>
                {currentChild}
                <div className="mt-3">
                    <button onClick={() => setStep(s => s + 1)} block size="lg" className="bg-gradient-primary text-white btn shadow btn-rounded btn-lg btn-block">
                        Continuar
          </button>
                </div>
            </div>
        );
    } else {
        return (
            <div {...props}>
                <LineStepper current={step}></LineStepper>
                {currentChild}
            </div>
        );
    }

}

export default NavsTransfer;
